/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ArrowDownward } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Bar, BarChart, Brush, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatDate, helpers } from '../../../services/helpers/helpers';

interface IBarChart {
    data: any[],
    name: string,
    barKey: string[],
    yAxis: string,
    yText: string,
    xAxis: string,
    multBar?: boolean,
}

export const Pluviometry = ({ data, barKey, name, xAxis, yAxis, yText, multBar }: IBarChart) => {
    if (!data || !Array.isArray(data)) {
        return <div>Erro: Dados inválidos</div>;
    }

    if (data.length === 0) {
        return <div>Nenhum dado disponível</div>;
    }

    const sanitizedData = data.map((item, index) => {
        const newItem = { ...item };

        barKey.forEach(key => {
            if (key in newItem) {
                const valor = Number(newItem[key]);
                if (isNaN(valor) || !isFinite(valor)) {
                    newItem[key] = 0;
                } else {
                    newItem[key] = valor;
                }
            }
        });

        if (yAxis && yAxis in newItem) {
            const valor = Number(newItem[yAxis]);
            if (isNaN(valor) || !isFinite(valor)) {
                newItem[yAxis] = 0;
            } else {
                newItem[yAxis] = valor;
            }
        }

        return newItem;
    });

    const [barSize, setBarSize] = useState<number | undefined>(undefined);

    const handleBarSizeChange = (event: any) => {
        if (event.target.value === '') {
            setBarSize(undefined);
        } else {
            setBarSize(Number(event.target.value));
        }
    };

    return (
        <Container>
            <Box width={'100%'} justifyContent={'center'} alignContent={'center'} padding={1} gap={1}>
                <Box width={'100%'}>
                    <Typography variant='h6'>{name}</Typography>
                    <ResponsiveContainer width={'100%'} height={300}>
                        <BarChart
                            key={`barChart-${barSize}`}
                            data={sanitizedData}
                            barCategoryGap={0} 
                            barGap={0}        
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >

                            <CartesianGrid strokeDasharray={'3 3'} />
                            <XAxis dataKey={xAxis} tickFormatter={helpers.formatXAxisDate} />
                            <YAxis
                                dataKey={yAxis}
                                label={{ value: yText, angle: -90, position: 'insideLeft', dy: 70, dx: -30 }}
                                domain={[0, 'dataMax']}
																tickFormatter={(value) => value.toFixed(2)}
                            />
                            <Brush dataKey={xAxis} height={25} tickFormatter={formatDate} />
                            <Tooltip />
                            {/* <Legend/> */}
                            {barKey.map(key => {
                                return (
                                    <Bar
                                        key={key}
                                        dataKey={key}
                                        fill={`#${Math.floor(Math.random() * 16777215).toString(16)}`}
                                        barSize={barSize ?? 10}
                                    />

                                );
                            })}
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
                <Box width={'100%'}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ArrowDownward />}>
                            Personalização do Gráfico
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Grid container>
                                    <Grid item>
                                        <TextField
                                            label='Tamanho da barra'
                                            value={barSize || ''}
                                            type='number'
                                            variant='filled'
                                            onChange={handleBarSizeChange}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
        </Container>
    );
};